export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const TOKEN_SENT = 'TOKEN_SENT';
export const JOB_OFFER_ACCEPT = 'JOB_OFFER_ACCEPT';
export const SET_EXPIRATION_TIME = 'SET_EXPIRATION_TIME';
export const IS_LOADING = 'IS_LOADING';